import { lazy } from 'react';

// Trust Stream (Automation Visibility)
export const TrustStreamPage = lazy(() =>
  import('@/platform/trust/pages/TrustStreamPage').then((m) => ({ default: m.TrustStreamPage }))
);
